import React from "react";

import { useDictionary } from "hooks";

import styles from "./styles.css";
import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";
import { FIELD_TYPES } from "globals/constants";

const defaultDictionary = {
    ruleFieldAffected:
        "The changed field below is associated with a review rule. Changing the value may impact the routing chain for this record. Be sure to confirm the change is desired before saving the updated value.",
    accessFieldAffected:
        "The changed field below impacts which users have access to this record. Be sure to confirm the change is desired before saving the updated value.",
    researchTeamLabel: "Research Team Object",
};

export const FormEditWarning = ({ rules, accesses }) => {
    const dictionary = useDictionary("common.formEditWarning");

    const getRecord = (field) => {
        if (field.type === FIELD_TYPES.RESEARCH_TEAM) {
            const label =
                dictionary.researchTeamLabel ||
                defaultDictionary.researchTeamLabel;

            return field.section ? `${field.section}: ${label}` : label;
        }

        return field.section ? `${field.section}: ${field.label}` : field.label;
    };

    return (
        <React.Fragment>
            {isNonEmptyArray(rules) && (
                <React.Fragment>
                    <h4 className={styles.title}>
                        {dictionary.ruleFieldAffected ||
                            defaultDictionary.ruleFieldAffected}
                    </h4>
                    <ul className={styles.list}>
                        {rules.map((item, k) => (
                            <li key={k}>
                                <p>{getRecord(item)}</p>
                            </li>
                        ))}
                    </ul>
                </React.Fragment>
            )}

            {isNonEmptyArray(accesses) && (
                <React.Fragment>
                    <h4 className={styles.title}>
                        {dictionary.accessFieldAffected ||
                            defaultDictionary.accessFieldAffected}
                    </h4>
                    <ul className={styles.list}>
                        {accesses.map((item, k) => (
                            <li key={k}>
                                <p>{getRecord(item)}</p>
                            </li>
                        ))}
                    </ul>
                </React.Fragment>
            )}
        </React.Fragment>
    );
};
